"use client";
import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { memo as h } from "react";
import r from "../components/Icon/SvgIcon.js";
const l = (e) => /* @__PURE__ */ t(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ o("path", { fill: "#fff", d: "M5 5h14v14H5z" }),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
        }
      )
    ]
  }
), c = h(l);
export {
  c as CheckboxChecked,
  c as default
};
